import React, { useState, useEffect } from "react";
import Footer from "../footer/Footer";
import { Link } from "react-router-dom";
import _ from "lodash";
import Header from "../header/Header";
import Site from "../settings/Site";
import Email from "../common/mailer/Scheduler";
import Schedulers from "../common/mailer/Schedulers";
import * as utils from "../../../src/common/utils";
import Noaccess from "../../../src/components/common/NoAccess";
import ModuleMenu from "../common/moduleMenu/ModuleMenu";
import GalleryManager from "../galleryManager/GalleryManager";
import MassCommunication from "../massCommunication/MassCommunication";
import EmailScheduler from "../common/mailer/EmailScheduler";
import ReasonCodesforAdmin from "./ReasonCodesforAdmin";
import SMESSReasonCode from "./SMESSReasonCode";
import SixMConfiguration from "./6MConfiguration";
import Language from './Language';

const AdminConsole = (props) => {
  const [animate, setAnimate] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, []);

  const components = [
    { id: 0, text: "Site", icon: "product", component: <Site isSA="true" /> },
    { id: 1, text: "Mailing", icon: "email", component: <EmailScheduler /> },
   // { id: 2, text: "Gallery", icon: "", component: <GalleryManager /> },
    {
      id: 2,
      text: "Mass Communications",
      icon: "",
      component: <MassCommunication />,
    },
    // {
    //   id: 3,
    //   text: "Standard Reason Codes",
    //   icon: "",
    //   component: <ReasonCodesforAdmin />,
    // },
    {
      id: 3,
      text: "SMESS Reason Codes",
      icon: "",
      component: <SMESSReasonCode />,
    },
    {
      id: 4,
      text: "6M Configuration",
      icon: "",
      component: <SixMConfiguration />,
    },
    { id: 5, text: 'Language', icon: '', component: <Language /> },
  ];

  //const components = [
  //    { id: 0, text: 'EMail Coms', icon: 'email', component: <EmailScheduler /> },
  //    { id: 1, text: 'Email', icon: '', component: <Email isEmail={true} showTemplateEditor={true} /> },
  //    { id: 2, text: 'Email Scheduler', icon: '', component: <Schedulers show={true} /> },
  //    { id: 3, text: 'Gallery', icon: '', component: <GalleryManager /> },
  //    { id: 4, text: 'Mass Communications', icon: '', component: <MassCommunication /> }
  //];

  return !utils.get("isAdmin") ? (
    <>
      <Noaccess isAdminConsole={true} />
    </>
  ) : (
    <>
      <Header showPinBtn={false} site={[]} />

      <section className="page-content">
        <div className="site-view tier-wrap admin-console-wrapper">
          <div className={"site-list " + animate}>
            <div className="breadcrumb">
              <span className="icon icon-corporate"></span>
              <ul>
                <li>
                  <Link to={`/`}>Home</Link>
                </li>
                <li>Admin Console</li>
              </ul>
            </div>
            <div className="site-head">
              <div className="page-heading">
                <h2>
                  <span className="icon setting"></span> Admin Console
                </h2>
              </div>
              {/*<div style={{ "width": "30%", "textAlign": "right" }}> <span className="cbtn" style={{ "float": "right", "margin": "0px" }}><Link to={'/tiers/layout'}><button className="btn secondary-btn"  ><i className="fas fa-edit"></i>&nbsp; Default Layout</button></Link></span></div>*/}
            </div>

            <ModuleMenu componentsData={components} />
          </div>
        </div>
      </section>
    </>
  );
};
export default AdminConsole;
//<Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
